import { BUILDINGS } from "../constants";
import {
  FLAG_COUNTER_PADDING,
  FLAG_COUNTER_ICON_SIZE,
  FLAG_COUNTER_ICON_PADDING,
  FLAG_COUNTER_TEXT_PADDING,
  FLAG_COUNTER_FONT_SIZE,
  FLAG_COUNTER_BG_COLOR,
  FLAG_COUNTER_CORNER_RADIUS,
} from "../constants";

export const drawFlagCounter = (
  ctx: CanvasRenderingContext2D,
  visitedCount: number,
  canvasWidth: number,
  canvasHeight: number
): void => {
  ctx.save();
  ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset transform to screen coordinates

  const totalCount = BUILDINGS.length;
  const counterText = `Flags: ${visitedCount}/${totalCount + 1}`;

  // Measure text
  ctx.font = `bold ${FLAG_COUNTER_FONT_SIZE}px sans-serif`;
  ctx.textAlign = "left";
  ctx.textBaseline = "top";
  const textMetrics = ctx.measureText(counterText);
  const textWidth = textMetrics.width;
  const textHeight = FLAG_COUNTER_FONT_SIZE;

  // Calculate background dimensions
  const bgWidth = FLAG_COUNTER_ICON_SIZE + FLAG_COUNTER_ICON_PADDING + textWidth + FLAG_COUNTER_TEXT_PADDING * 2;
  const bgHeight = Math.max(FLAG_COUNTER_ICON_SIZE, textHeight) + FLAG_COUNTER_TEXT_PADDING * 2;
  const bgX = canvasWidth - FLAG_COUNTER_PADDING - bgWidth;
  const bgY = FLAG_COUNTER_PADDING;

  // Draw blue background with rounded corners
  ctx.fillStyle = FLAG_COUNTER_BG_COLOR;
  const cornerRadius = FLAG_COUNTER_CORNER_RADIUS;
  ctx.beginPath();
  ctx.moveTo(bgX + cornerRadius, bgY);
  ctx.lineTo(bgX + bgWidth - cornerRadius, bgY);
  ctx.quadraticCurveTo(bgX + bgWidth, bgY, bgX + bgWidth, bgY + cornerRadius);
  ctx.lineTo(bgX + bgWidth, bgY + bgHeight - cornerRadius);
  ctx.quadraticCurveTo(bgX + bgWidth, bgY + bgHeight, bgX + bgWidth - cornerRadius, bgY + bgHeight);
  ctx.lineTo(bgX + cornerRadius, bgY + bgHeight);
  ctx.quadraticCurveTo(bgX, bgY + bgHeight, bgX, bgY + bgHeight - cornerRadius);
  ctx.lineTo(bgX, bgY + cornerRadius);
  ctx.quadraticCurveTo(bgX, bgY, bgX + cornerRadius, bgY);
  ctx.closePath();
  ctx.fill();

  // Draw flag icon
  const iconX = bgX + FLAG_COUNTER_TEXT_PADDING;
  const iconY = bgY + (bgHeight - FLAG_COUNTER_ICON_SIZE) / 2;

  // Draw flag pole
  ctx.fillStyle = "#8b7355"; // Brown pole
  ctx.fillRect(iconX, iconY, 3, FLAG_COUNTER_ICON_SIZE);

  // Draw flag triangle
  ctx.fillStyle = "#ff0000"; // Red flag
  ctx.beginPath();
  ctx.moveTo(iconX + 3, iconY);
  ctx.lineTo(iconX + 3 + FLAG_COUNTER_ICON_SIZE * 0.7, iconY + FLAG_COUNTER_ICON_SIZE / 2);
  ctx.lineTo(iconX + 3, iconY + FLAG_COUNTER_ICON_SIZE);
  ctx.closePath();
  ctx.fill();

  // Draw text with outline
  const textX = iconX + FLAG_COUNTER_ICON_SIZE + FLAG_COUNTER_ICON_PADDING;
  const textY = bgY + (bgHeight - textHeight) / 2;
  ctx.fillStyle = "#ffffff";
  ctx.strokeStyle = "#000000";
  ctx.lineWidth = 2;
  ctx.strokeText(counterText, textX, textY);
  ctx.fillText(counterText, textX, textY);

  ctx.restore();
};

